module.exports = __webpack_public_path__ + "static/media/pdf-icon.636375ef.svg";